export default __webpack_public_path__ + "static/media/scaledrone.7a3768ac.svg";